export default __webpack_public_path__ + "static/media/logo-mark.56a03b4c.svg";